"use strict";
/** state: Final **/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var react_date_picker_1 = require("react-date-picker");
var FontAwesome_1 = require("../FontAwesome");
var IconWrapper_1 = require("../IconWrapper");
var Input_1 = require("../Input");
var CLASS_NAME = 'i-date-picker';
var DatePickerView;
(function (DatePickerView) {
    DatePickerView["Month"] = "month";
    DatePickerView["Year"] = "year";
    DatePickerView["Decade"] = "decade";
    DatePickerView["Century"] = "century";
})(DatePickerView = exports.DatePickerView || (exports.DatePickerView = {}));
var DatePicker = (function (_a) {
    var className = _a.className, readOnly = _a.readOnly, showClearIcon = _a.showClearIcon, isOpen = _a.isOpen, locale = _a.locale, maxDate = _a.maxDate, minDate = _a.minDate, onChange = _a.onChange, onClickDay = _a.onClickDay, onClickDecade = _a.onClickDecade, onClickMonth = _a.onClickMonth, onClickYear = _a.onClickYear, showWeekNumbers = _a.showWeekNumbers, value = _a.value, view = _a.view, restProps = __rest(_a, ["className", "readOnly", "showClearIcon", "isOpen", "locale", "maxDate", "minDate", "onChange", "onClickDay", "onClickDecade", "onClickMonth", "onClickYear", "showWeekNumbers", "value", "view"]);
    var _b;
    var buildDate = function (date) {
        if (!date) {
            return '';
        }
        var day = Number(date.getDate()).toLocaleString(undefined, {
            minimumIntegerDigits: 2,
            useGrouping: false,
        });
        var month = Number(date.getMonth() + 1).toLocaleString(undefined, {
            minimumIntegerDigits: 2,
            useGrouping: false,
        });
        var year = date.getFullYear();
        return year + "-" + month + "-" + day;
    };
    if (readOnly) {
        return (React.createElement(Input_1.Input, __assign({ className: classNames(CLASS_NAME, className), readOnly: true, type: Input_1.Input.Type.Date, value: buildDate(value) }, restProps)));
    }
    return (React.createElement(react_date_picker_1.default, __assign({ className: classNames(CLASS_NAME, 'form-control', className, (_b = {},
            _b[CLASS_NAME + "--show-clear"] = showClearIcon,
            _b)), calendarClassName: CLASS_NAME + "__calendar", calendarIcon: React.createElement(IconWrapper_1.IconWrapper, null,
            React.createElement(FontAwesome_1.FontAwesome, { name: "calendar" })), clearIcon: React.createElement(IconWrapper_1.IconWrapper, null,
            React.createElement(FontAwesome_1.FontAwesome, { name: "close" })), nextLabel: React.createElement(IconWrapper_1.IconWrapper, null,
            React.createElement(FontAwesome_1.FontAwesome, { name: "chevron-right" })), prevLabel: React.createElement(IconWrapper_1.IconWrapper, null,
            React.createElement(FontAwesome_1.FontAwesome, { name: "chevron-left" })), tileClassName: CLASS_NAME + "__calendar__tile", isOpen: isOpen, locale: locale, maxDate: maxDate, minDate: minDate, onChange: onChange, onClickDay: onClickDay, onClickDecade: onClickDecade, onClickMonth: onClickMonth, onClickYear: onClickYear, showWeekNumbers: showWeekNumbers, value: value, view: view }, restProps)));
});
exports.DatePicker = DatePicker;
DatePicker.View = DatePickerView;
DatePicker.defaultProps = {
    locale: 'en-AU',
    readOnly: false,
    showClearIcon: false,
};
//# sourceMappingURL=DatePicker.js.map